<div class="header" style="padding: 0px; margin-bottom: 1rem">
  <div class="nav-wrapper">
    <kendo-appbar position="top" class="navbar">
      <kendo-appbar-section class="logo-section">
        <img src="../../../assets/kpmg-logo.svg" alt="Logo" class="logo" loading="lazy" />
        <span class="k-appbar-separator"></span>
        <h1 class="title">Advisory Risk Services Platform</h1>
      </kendo-appbar-section>
      <kendo-appbar-spacer></kendo-appbar-spacer>
      <kendo-appbar-section class="actions">
        <notification-bell class="vertical-align-bell"></notification-bell>
        <span class="k-appbar-separator"></span>
      </kendo-appbar-section>

      <kendo-appbar-section>
        <kendo-dropdownbutton
          class="user-profile-dropdown"
          [data]="UserProfile"
          style="color: #00338d; border-radius: 50%"
          fillMode="link"
          themeColor="none"
          size="none"
          [popupSettings]="{ popupClass: 'profile-popup', animate: true }"
          #profileDropdown
          >
          <kendo-avatar
            [initials]="loggedInUserDetails.userInitials"
            [fillMode]="'solid'"
            shape="circle"
            size="small"
            class="sign-out-avatar main-avatar"
          ></kendo-avatar>

          <ng-template kendoDropDownButtonItemTemplate let-profile>
            <div class="profile-item" (click)="$event.stopPropagation()">
              <div class="list">
                @if (profile.text === UserProfile[0].text) {
                  <div
                    class="sign-out center"
                    (click)="onDropdownButtonClick(profile)"
                    >
                    Sign Out
                  </div>
                  <br />
                  <div class="contact">
                    <div class="k-hstack">
                      <kendo-avatar
                        [initials]="loggedInUserDetails.userInitials"
                        [fillMode]="'solid'"
                        shape="circle"
                        size="large"
                        class="sign-out-avatar inside-avatar"
                        >
                      </kendo-avatar>
                      <div class="center">
                        <div>
                          <h2
                            class="ellipse"
                              [title]="
                                loggedInUserDetails.lastName +
                                ', ' +
                                loggedInUserDetails.firstName
                              "
                            >
                            {{ loggedInUserDetails.lastName }},
                            {{ loggedInUserDetails.firstName }}
                          </h2>
                          <p
                            class="ellipse"
                            [title]="loggedInUserDetails.email"
                            >
                            {{ loggedInUserDetails.email }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </ng-template>
        </kendo-dropdownbutton>
      </kendo-appbar-section>
    </kendo-appbar>
  </div>
  <kendo-card
    class="w-100"
    style="height: auto; border-radius: 0; border: none"
    >
    <kendo-card-header
      class="k-d-flex k-justify-content-between"
      style="
        padding: 0.563rem 1.25rem;
        background-color: white;
        border: none;
        border-bottom: 1px solid rgba(33, 33, 33, 0.15);
      "
      >
      <div>
        <nav>
          <ol
            class="flex"
            style="list-style-type: none"
            style="margin: 0px; padding-left: 0"
            >
            @for (route of breadcrumbs; track route; let last = $last; let i = $index) {
              @if (!last) {
                <li
                  style="cursor: pointer; display: inline-block"
                  class="breadcrumb-item"
                  >
                  <button
                    kendoButton
                    fillMode="link"
                    [routerLink]="route.url"
                  style="
                    color: #00338d;
                    text-decoration: none !important;
                    box-shadow: none !important;
                    padding: 6px;
                  "
                    >
                    @if (i === 0 || breadcrumbs.length === 1) {
                      <span
                        style="padding-right: 5px"
                        ><kendo-svg-icon
                        [icon]="homeIcon"
                        style="vertical-align: text-top"
                        ></kendo-svg-icon
                      ></span>
                    }
                    @if (
                      loggedInUserRole ===
                      userRoles.EngagementApproverUserRole &&
                      route.label === 'Dashboard'
                      ) {
                      <span
                        >Approver</span
                        >
                      }
                      @if (
                        loggedInUserRole === userRoles.SupportUserRole &&
                        route.label === 'Dashboard'
                        ) {
                        <span
                          >Support</span
                          >
                        }
                        {{ route.label }}
                      </button>
                    </li>
                  }
                  @if (!last) {
                    <li
                      style="margin-left: 0; margin-right: 0; display: inline-block"
                      class="breadcrumb-item"
                      >
                      <kendo-avatar
                        [svgIcon]="chevronRightIcon"
                        class="kendo-button"
                        style="color: #00338d; margin: -20px; vertical-align: sub"
                        >
                      </kendo-avatar>
                    </li>
                  }
                  @if (last) {
                    <li
                      style="cursor: pointer; display: inline-block"
                      class="breadcrumb-item"
                      >
                      <button
                        kendoButton
                        fillMode="link"
                  style="
                    color: #00338d;
                    text-decoration: none !important;
                    box-shadow: none !important;
                    padding: 6px;
                  "
                        >
                        @if (i === 0 || breadcrumbs.length === 1) {
                          <span
                            style="padding-right: 5px"
                            ><kendo-svg-icon
                            [icon]="homeIcon"
                            style="vertical-align: text-top"
                            ></kendo-svg-icon
                          ></span>
                        }
                        @if (
                          loggedInUserRole ===
                          userRoles.EngagementApproverUserRole &&
                          route.label === 'Dashboard'
                          ) {
                          <span
                            >Approver</span
                            >
                          }
                          @if (
                            loggedInUserRole === userRoles.SupportUserRole &&
                            route.label === 'Dashboard'
                            ) {
                            <span
                              >Support</span
                              >
                            }
                            @if (i > 2) {
                              <!-- {{ route.label }} -->
                              <div class="ellipse"
                                kendoTooltip
                                filter="span"
                                >
                                <span class="ellipse" title="{{ route.label}}">
                                  {{ route.label }}
                                </span>
                              </div>
                            } @else {
                              {{ route.label }}
                            }
                          </button>
                        </li>
                      }
                    }
                  </ol>
                </nav>
              </div>
              <div class="k-p-0 k-d-flex">
                <!-- <button kendoButton *ngIf="enableEngageButton()" class="kendo-button">
                KPMG Engage
              </button> -->
              @if (loggedInUserRole === userRoles.SupportUserRole) {
                <button
                  kendoButton
                  (click)="downloadClientUsageReportForSupportUsers()"
                  [svgIcon]="downloadIcon"
                  class="kendo-button"
                  >
                  Download Usage Stats
                </button>
              }

              <button
                kendoButton
                (click)="onNewEngagementClick()"
                [svgIcon]="plusIcon"
                class="kendo-button"
                >
                Request New Engagement
              </button>
              <span #anchor class="anchor"></span>
            </div>
          </kendo-card-header>
        </kendo-card>
      </div>

      <!-- Request Engagement and Approve popup component -->
      <!-- <app-request-engagement-and-approve [openRequestAndApproveEngagementPopup]="isRequestAndApproveEngagementPopupOpen"
      (closeEvent)="onRequestAndApproveEngagementPopupClose()"
      [anchor]="anchor">
    </app-request-engagement-and-approve > -->

    <!--Engagement Request popup component -->
    <app-engagementrequest
      [openRequestEngagementPopup]="isRequestAndApproveEngagementPopupOpen"
      (closeEvent)="onRequestAndApproveEngagementPopupClose()"
      [anchor]="anchor"
      [margin]="margin"
      >
    </app-engagementrequest>
